const enPortal = {
  common: {
    language: 'Language',
    english: 'English',
    spanish: 'Spanish',
    workOrders: 'Work Orders',
    documents: 'Documents',
    directions: 'Directions',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    saving: 'Saving...',
    generating: 'Generating...',
    submitting: 'Submitting...',
    uploading: 'Uploading...',
    loadingPhotos: 'Loading photos...',
    noPhotosYet: 'No photos yet',
    recentPhotos: 'Recent Photos',
    projectPhotos: 'Project Photos',
    opportunities: 'Opportunities',
    poweredBy: 'Powered by Level Up Roofing CRM',
    reviewedOn: 'Reviewed {{date}}',
    expiresOn: 'Expires {{date}}',
    submittedOn: 'Submitted {{date}}',
    tbd: 'TBD',
    yes: 'Yes',
    no: 'No',
    qtyFallback: 'qty',
    languageToggleAria: 'Switch portal language',
  },
  documentsOverview: {
    missing: 'Missing',
    expiring: 'Expiring',
    allSet: 'All Set',
  },
  errors: {
    invalidOrExpiredLink: 'Invalid or expired link',
    linkNotFoundTitle: 'Link Not Found',
    linkNotFoundBody: 'This portal link is invalid or has been revoked. Contact your contractor for a new link.',
    networkError: 'Network error',
    requestFailed: 'Request failed',
    invalidPortalLink: 'Invalid portal link',
    workOrderNotFound: 'Work order not found',
    installDateRequired: 'Install date is required',
    invalidDate: 'Invalid date',
    gutterAcceptInvalidState: 'This work order cannot be accepted in its current state.',
    roofInstallWaitingDate: 'A roof installation is pending and has not been scheduled yet. Please wait until the roof installation date is confirmed.',
    roofInstallConflict: 'Gutter installation must be scheduled after the roof installation ends on {{date}}.',
    companyCamUnavailable: 'CompanyCam is not configured for this project.',
    generateInviteFailed: 'Failed to generate invite link.',
    onlyPdfFilesAllowed: 'Only PDF files are allowed.',
    noFileUploaded: 'No file uploaded.',
    invoiceUploadFailed: 'Upload failed.',
    invoiceUploadInvalidState: 'Invoice uploads are only available for scheduled or awaiting-payment work orders.',
    requestPaymentInvalidState: 'This work order must be scheduled before you can request payment.',
    paymentAmountRequired: 'Enter a valid payment amount.',
    invoiceRequiredBeforePayment: 'Upload an invoice before requesting payment.',
    acceptFailed: 'Failed to accept work order.',
    requestPaymentFailed: 'Failed to request payment.',
    opportunityResponseFailed: 'Failed to update the opportunity.',
    workOrderStartInvalidState: 'This work order cannot be started in its current state.',
    invalidWorkStage: 'Invalid work stage.',
    workOrderSliderLocked: 'This work order can no longer be moved from the portal slider.',
    finalsPredeterminedOnly: 'Final quantity submission is only available for pre-determined pricing work orders.',
    finalsRequireCompleted: 'Final quantities can only be submitted after the work order is marked complete.',
    noPayoutLineItems: 'This work order does not have payout line items to submit.',
    completeBeforeReadyForPayReview: 'Complete the work order before moving it to Ready for Pay Review.',
    serverError: 'Server error',
  },
  compliance: {
    title: 'Documents',
    subtitle: 'Upload or replace compliance documents for your company profile.',
    sameInsurancePolicy: "Worker's Comp is on the same policy as General Liability",
    needsAttention: 'Needs attention:',
    noFile: 'No file uploaded yet.',
    viewCurrentDocument: 'View current document',
    carrierProvider: 'Carrier / Provider',
    policyNumber: 'Policy Number',
    effectiveDate: 'Effective Date',
    expirationDate: 'Expiration Date',
    notesForAdminReview: 'Notes for admin review',
    allowedTypes: 'Allowed: PDF, JPEG, or HEIC. Uploaded images are converted to WEBP.',
    replaceDocument: 'Replace Document',
    uploadDocument: 'Upload Document',
    updated: '{{label}} updated.',
    reviewLanguageNote: 'Office review notes may still appear in English.',
    definitions: {
      general_liability: {
        label: 'General Liability Insurance',
        description: 'Certificate of liability insurance, policy details, and expiration.',
      },
      workers_comp: {
        label: "Workers' Comp Insurance",
        description: "Workers' comp certificate, carrier details, and expiration.",
      },
      w9: {
        label: 'W-9',
        description: 'Current tax form kept on file for accounting and payout setup.',
      },
    },
    statusMeta: {
      missing: 'Missing',
      submitted: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      expired: 'Expired',
      expiring_soon: 'Expiring Soon',
    },
  },
  languageToggle: {
    englishShort: 'EN',
    spanishShort: 'ES',
  },
  subPortal: {
    filters: {
      upcoming: 'Upcoming Work ({{count}})',
      review: 'Action / Review ({{count}})',
      completed: 'Completed ({{count}})',
      opportunities: 'Opportunities ({{count}})',
    },
    empty: {
      upcoming: 'No upcoming work orders',
      review: 'No work orders under review',
      completed: 'No completed work orders',
    },
    statusLabels: {
      draft: 'Draft',
      pending_completion: 'Pending Completion',
      in_progress: 'In Progress',
      completed: 'Ready for Final Totals',
      calculating_pay: 'PM Review Totals',
      pay_review: 'Pending Payout',
      paid: 'Paid',
    },
    stages: {
      unstarted: 'Unstarted',
      workStarted: 'Work Started',
      completed: 'Completed',
      readyForPayReview: 'Ready for Pay Review',
    },
    roofDetails: 'Roof Details',
    roofStats: {
      total: 'Total',
      standard: 'Standard',
      steep: 'Steep (>=7/12)',
      squaresUnit: 'sq',
      pitch: 'Pitch',
      squares: 'Squares',
      steepChip: 'Steep',
    },
    colorLabels: {
      shingleColor: 'Shingle Color',
      dripEdgeColor: 'Drip Edge Color',
    },
    buildingLabels: {
      mainHouse: 'Main House',
      house: 'House',
      garage: 'Garage',
      detachedGarage: 'Detached Garage',
      barn: 'Barn',
      shed: 'Shed',
      addition: 'Addition',
      carport: 'Carport',
      poolHouse: 'Pool House',
      shop: 'Shop',
      office: 'Office',
      porch: 'Porch',
      frontPorch: 'Front Porch',
      rearPorch: 'Rear Porch',
      buildingNumber: 'Building {{number}}',
    },
    payout: {
      roughEstimate: 'Rough Pay Estimate',
      finalWorksheet: 'Final Quantity Worksheet',
      paymentBreakdown: 'Payment Breakdown',
      roughEstimateNote: 'Estimated payout based on the saved subcontractor rate card.',
      finalWorksheetNote: 'Enter the final installed quantities, then submit them to the office for review.',
      paymentBreakdownNote: 'Final quantities are under office review before payment is marked complete.',
      hideBreakdown: 'Hide payment breakdown',
      showBreakdown: 'Show payment breakdown',
      estimateBadge: 'Est.',
      readyBadge: 'Ready',
      finalBadge: 'Final',
      reimburseExtra: 'Reimburse / Extra:',
      notes: 'Notes:',
      finalLineItems: 'Final Line Item Quantities',
      zeroQtyNotice: 'Zero-quantity rows are shown by default so nothing gets missed.',
      showZeroLineItems: 'Show zero line items',
      tableItem: 'Item',
      tableEstimated: 'Estimated',
      tableFinal: 'Final',
      reimbursementNotePlaceholder: 'Reimbursement note...',
      completionNotesPlaceholder: 'Optional completion notes for the office...',
      submitFinalQuantities: 'Submit Final Quantities',
      lineItems: {
        perSquare: 'Squares',
        osbInstalled: 'OSB Installed',
        extraLayers: 'Squares of Extra Layers',
        skylights: 'Skylights',
        smallChimneyReflash: 'Small Chimney - Reflashed',
        largeChimneyReflash: 'Large Chimney - Reflashed',
        steepPerStep: 'Steep (per step)',
        dump: 'Dump',
      },
    },
    tasks: 'Tasks',
    taskContent: {
      protectLandscaping: 'Protect landscaping',
      stageMaterials: 'Stage materials',
      tearOffExistingRoof: 'Tear off existing roof',
      inspectDecking: 'Inspect decking',
      replaceDamagedDecking: 'Replace damaged decking',
      installIceWaterShield: 'Install ice and water shield',
      installSyntheticUnderlayment: 'Install synthetic underlayment',
      installDripEdge: 'Install drip edge',
      installStarterStrip: 'Install starter strip',
      installShingles: 'Install shingles',
      installRidgeVent: 'Install ridge vent',
      installFlashing: 'Install flashing',
      haulDebris: 'Haul debris',
      cleanUp: 'Clean up',
      magneticSweep: 'Magnetic sweep',
      takeProgressPhotos: 'Take progress photos',
      uploadPhotosToCompanyCam: 'Upload photos to CompanyCam',
      finalWalkthrough: 'Final walkthrough',
      installSkylightSingle: 'Install {{count}} skylight',
      installSkylightPlural: 'Install {{count}} skylights',
      selectedUpgradeSections: 'Selected upgrade sections: {{sections}}',
    },
    statusCards: {
      finalQuantitiesSubmitted: 'Final Quantities Submitted',
      finalQuantitiesSubmittedBody: 'The office is reviewing your submitted quantities now.',
      pendingPayout: 'Pending Payout',
      pendingPayoutBody: 'Your totals were approved and are now queued for office payout.',
      completed: 'Work Order Completed',
      completedBody: 'This work order has been closed by the office.',
    },
  },
  gutterPortal: {
    headerSub: 'Gutter Portal',
    filters: {
      active: 'Active ({{count}})',
      awaiting: 'Awaiting Payment ({{count}})',
      paid: 'Paid ({{count}})',
      opportunities: 'Opportunities ({{count}})',
    },
    empty: {
      active: 'No active gutter work orders',
      awaiting: 'No awaiting-payment gutter work orders',
      paid: 'No paid gutter work orders',
    },
    statusLabels: {
      draft: 'New',
      pending_install_date: 'Needs Install Date',
      scheduled: 'Scheduled',
      awaiting_payment: 'Awaiting Payment',
      paid: 'Paid',
    },
    specs: {
      title: 'Gutter Specifications',
      singleStoryGutters: '1st Story Gutters (LF)',
      secondStoryGutters: '2nd Story Gutters (LF)',
      gutterSize: 'Gutter Size',
      downspouts: 'Downspouts',
      secondStoryDownspouts: '2nd Story Downspouts',
      gutterGuards: 'Gutter Guards (LF)',
      gutterColor: 'Gutter Color',
      colorFallback: 'Color',
    },
    colorGroups: {
      general: 'General',
    },
    roofInstall: {
      waitingDate: 'Roof installation pending — awaiting scheduled date. Gutter install date cannot be set yet.',
      scheduled: 'Roof installation scheduled — ends {{date}}. Gutter install must be after this date.',
      completed: 'Roof installation completed{{suffix}}.',
      completedSuffix: ' on {{date}}',
      endsLabel: 'Roof install ends: {{date}} — pick a date after this.',
    },
    installDate: 'Install Date: {{date}}',
    companyCam: {
      projectPhotos: 'CompanyCam Project Photos',
      joinProject: 'Join Project on CompanyCam',
      linkExpires: 'Link expires {{date}}',
      expired: 'Expired',
      getNewInviteLink: 'Get New Invite Link',
      inviteGeneratedAfterAccept: 'Invite link will be generated when you accept this work order.',
    },
    projectManager: 'Project Manager:',
    actions: {
      acceptAndSetInstallDate: 'Accept & Set Install Date',
      replaceInvoice: 'Replace Invoice',
      uploadInvoice: 'Upload Invoice',
      requestPayment: 'Request Payment',
    },
    payment: {
      requestSubmitted: 'Payment Request Submitted',
      invoiceSubmitted: 'Invoice: {{fileName}} - Submitted {{date}}',
      reviewMessage: 'Your payment request is being reviewed.',
      paidTitle: 'Paid',
      paidBody: 'Payment has been processed by the office.',
      requestTitle: 'Request Payment',
      requestDescription: 'Enter the total amount from your invoice.',
      amountPlaceholder: '0.00',
      submitForPayment: 'Submit for Payment',
    },
    acceptModal: {
      title: 'Accept & Schedule',
      description: 'Select your gutter installation date. The date must be after any scheduled roof installation.',
      confirm: 'Confirm & Schedule',
      scheduling: 'Scheduling...',
    },
  },
  opportunities: {
    empty: 'No opportunities available right now',
    locationTbd: 'Location shared after acceptance',
    schedule: 'Suggested Schedule',
    scheduleTbd: 'Schedule TBD',
    estimatedPayout: 'Estimated Payout',
    photos: 'Selected Photos',
    punchList: {
      title: 'Crew Punch-List',
      description: 'Expected work included with this opportunity.',
    },
    measurements: {
      estimatedSquares: 'Estimated Squares',
      squaresUnit: 'sq',
    },
    specLabels: {
      specification: 'Specification',
      pitch: 'Pitch',
      material: 'Material',
      color: 'Color',
      shingleColor: 'Shingle Color',
      gutterSize: 'Gutter Size',
      gutterColor: 'Gutter Color',
      linearFeet: 'Linear Feet',
      downspouts: 'Downspouts',
      stories: 'Stories',
      layers: 'Layers',
      style: 'Style',
      sections: 'Sections',
      sidingType: 'Siding Type',
      panelType: 'Panel Type',
      gauge: 'Gauge',
      repairScope: 'Repair Scope',
      windowCount: 'Window Count',
    },
    deadline: {
      title: 'Response Deadline',
      respondBy: 'Respond by {{date}}',
      expired: 'Expired',
      daysLeft: '{{count}}d left',
      hoursLeft: '{{count}}h left',
      minutesLeft: '{{count}}m left',
    },
    actions: {
      accept: 'Accept',
      decline: 'Decline',
      accepting: 'Accepting...',
      declining: 'Declining...',
      confirmAccept: 'Confirm Accept',
      confirmDecline: 'Confirm Decline',
      confirmAcceptTitle: 'Accept this opportunity?',
      confirmDeclineTitle: 'Decline this opportunity?',
      confirmAcceptBody: 'We will refresh your portal after you accept this opportunity.',
      confirmDeclineBody: 'We will refresh your portal after you decline this opportunity.',
    },
    types: {
      roofing: 'Roofing',
      flat_roofing: 'Flat Roofing',
      metal_roofing: 'Metal Roofing',
      siding: 'Siding',
      soffit_fascia: 'Soffit / Fascia',
      gutters: 'Gutters',
      windows: 'Windows',
      repairs: 'Repairs',
      default: 'Work',
    },
  },
};

export default enPortal;
